const enTranslations = {
  // =========================
  // NAVIGATION
  // =========================
  "floating.contact": "Contact us",
  "floating.phone": "Phone:",
  "header.about": "About",
  "header.careers": "Careers",
  "header.construction": "Construction",
  "header.contact": "Contact",
  "header.home": "Home",
  "header.mining": "Mining",
  "header.realEstate": "Real Estate Development",
  "language.en": "English",
  "language.fr": "Français",

  // =========================
  // HOME
  // =========================
  "home.chiffres.collaborateurs": "Employees",
  "home.chiffres.collaborateursLabel": "Employees\n(Head office + sites)",
  "home.chiffres.filiales": "Subsidiaries",
  "home.chiffres.filialesLabel": "Subsidiaries: Keur Invest\n& SOCABEG Mining",
  "home.chiffres.highlight": "OUR IMPACT",
  "home.chiffres.parcelles": "Plots",
  "home.chiffres.parcellesLabel": "Serviced plots\nand delivered housing",
  "home.chiffres.patrimoine": "Land assets",
  "home.chiffres.patrimoineLabel": "Hectares of\nland assets",
  "home.chiffres.title": "KEY FIGURES",
  "home.chiffres.voiries": "Roads and utilities\ncompleted",
  "home.hero.contact": "Contact us",
  "home.hero.description": "A major player in Senegal in the fields of construction, real estate development and mining.",
  "home.hero.highlight": "Building a sustainable Senegal",
  "home.hero.slides.slide1.subtitle": "Over 5,000 homes delivered nationwide, shaping Senegal's urban landscape since 1986.",
  "home.hero.slides.slide1.title": "Leader in social housing construction in Senegal",
  "home.hero.slides.slide2.subtitle": "Our priority: simplifying property acquisition for our partners with turnkey solutions.",
  "home.hero.slides.slide2.title": "Innovate and build: our passion serving your projects",
  "home.hero.slides.slide3.subtitle": "Committed to a sustainable and high-quality future, where environmental harmony benefits our community.",
  "home.hero.slides.slide3.title": "Strong values for sustainably building your heritage",
  "home.hero.title": "WELCOME TO SOCABEG",
  "home.metiers.btp.description": "Design and build living spaces that inspire and connect.",
  "home.metiers.btp.title": "Construction",
  "home.metiers.description": "Explore our sectors — construction, real estate and mining — contributing to shape an innovative and sustainable Senegal.",
  "home.metiers.discover": "Learn more",
  "home.metiers.highlight": "COMPLEMENTARY BUSINESS LINES, SHARED VISION",
  "home.metiers.immobilier.description": "Harmonious developments where investment turns dreams into lasting heritage.",
  "home.metiers.immobilier.title": "Real Estate Development",
  "home.metiers.mines.description": "At the heart of mining innovation: resources forging progress",
  "home.metiers.mines.title": "Mining",
  "home.metiers.title": "OUR BUSINESS LINES",
  "home.partners.description": "SOCABEG collaborates with leading institutions and companies to deliver excellence in all our projects.",
  "home.partners.highlight": "TOGETHER, WE CREATE OPPORTUNITIES",
  "home.partners.list": [
    {
      "id": 1,
      "name": "BHS",
      "logo": "/images/partners/bhs.png",
      "url": "#"
    },
    {
      "id": 2,
      "name": "GEOPLAST",
      "logo": "/images/partners/geoplast.png",
      "url": "#"
    },
    {
      "id": 3,
      "name": "IPRES",
      "logo": "/images/partners/ipres.jpg",
      "url": "#"
    },
    {
      "id": 4,
      "name": "SAR",
      "parking": "Parking spaces",
      "superficie": "Area",
      "naturePapier": "Land title type",
      "statut": "Status",
      "surface": "Surface",
      "logo": "/images/partners/sar.png",
      "url": "#"
    },
    {
      "id": 5,
      "name": "SGS",
      "logo": "/images/partners/sgs.png",
      "url": "#"
    },
    {
      "id": 6,
      "name": "SICAP",
      "logo": "/images/partners/sicap.jpg",
      "url": "#"
    },
    {
      "id": 7,
      "name": "SN",
      "logo": "/images/partners/sn.jpg",
      "url": "#"
    },
    {
      "id": 8,
      "name": "SNHLM",
      "logo": "/images/partners/snhlm.jpg",
      "url": "#"
    },
    {
      "id": 9,
      "name": "SONATEL",
      "logo": "/images/partners/sonatel.png",
      "url": "#"
    }
  ],
  "home.partners.title": "OUR PARTNERS",
  "home.projects.highlight": "FEATURED PROGRAMS",
  "home.projects.title": "OUR PROJECTS",
  "home.testimonials.client1.name": "Amadou DIALLO",
  "home.testimonials.client1.position": "Entrepreneur",
  "home.testimonials.client1.quote": "I was able to diversify my real estate portfolio in just a few years thanks to their wide range of offers, successfully reaching my financial goals.",
  "home.testimonials.client2.name": "Marie SÈNE",
  "home.testimonials.client2.position": "Trader",
  "home.testimonials.client2.quote": "As a seller, the flexible payment options on certain SOCABEG programs were a great support. I was able to acquire property without going through banks, which was a real relief.",
  "home.testimonials.client3.name": "Ibrahima NDIAYE",
  "home.testimonials.client3.position": "Dentist",
  "home.testimonials.client3.quote": "Investing with SOCABEG has been an extremely rewarding experience. Not knowing where to start to buy land, they offered me opportunities I would never have discovered on my own. I highly recommend their services.",
  "home.testimonials.client4.name": "Moussa TRAORÉ",
  "home.testimonials.client4.position": "Retired",
  "home.testimonials.client4.quote": "Having rented for many years, I worked hard to provide a home for my family. This dream came true thanks to a housing program offered by SOCABEG. Their support was invaluable at every step.",
  "home.testimonials.client5.name": "Papa Moussa FALL",
  "home.testimonials.client5.position": "Teacher",
  "home.testimonials.client5.quote": "I am ultimately satisfied with SOCABEG's transparency and commitment. They managed to turn a long wait into a pleasant experience, despite some constraints that impacted project delivery.",
  "home.testimonials.client6.name": "TOIT IMMO",
  "home.testimonials.client6.position": "Real estate agency",
  "home.testimonials.client6.quote": "As a partner, we were able to complete a land servicing and construction project with SOCABEG. The quality of the collaboration was highly appreciated.",
  "home.testimonials.client7.name": "COHMECPN",
  "home.testimonials.client7.position": "Housing cooperative",
  "home.testimonials.client7.quote": "Our cooperative found in SOCABEG a reliable and competent partner for our social housing projects. Their expertise in cooperative housing and their commitment alongside members allowed us to deliver quality projects for our adherents.",
  "home.testimonials.description": "Discover what our clients and partners say about their experience with SOCABEG.",
  "home.testimonials.highlight": "THEY TRUST US",
  "home.testimonials.title": "TESTIMONIALS",
  "home.whoareus.description": "SOCABEG invests alongside Senegalese people to realize their real estate projects.",
  "home.whoareus.engagement1": "Founded in 1986 by Mr. Mamoune SAMB, SOCABEG has established itself as a major recognized player in construction and real estate development in Senegal. Today, the SOCABEG Group operates in construction (BTP), real estate development and the mining sector.",
  "home.whoareus.engagement2": "It enjoys very high visibility in the Senegalese business landscape, combining the skills of a well-equipped builder and site developer with extensive know-how acquired in social housing. SOCABEG has strong control over the value chain as a developer-builder, offering vertically integrated solutions and a product range aligned with the Senegalese real estate market.",
  "home.whoareus.engagement3": "The company has successfully completed numerous housing projects, land subdivisions, administrative office buildings, residential complexes and public buildings for public institutions, housing cooperatives and private clients. These achievements have strengthened our reputation.",
  "home.whoareus.engagement4": "It promotes the development and planning of eco-friendly residential and leisure neighborhoods, and virtuous buildings for better quality of life in an eco-responsible environment for the benefit of its clients. It remains firmly rooted in its core values: integrity, pursuit of quality, innovation and social responsibility, which guide all its activities and decisions.",
  "home.whoareus.engagement5": "By offering innovative, high-quality real estate projects at reasonable cost, it aims to combine construction excellence with financial accessibility. SOCABEG has played a key role in the emergence of new urban areas by building thousands of homes, thus meeting the needs of a broad segment of the Senegalese population with varied incomes.",
  "home.whoareus.highlight": "OVER 40 YEARS AT YOUR SERVICE",
  "home.whoareus.title": "WHO WE ARE",
  "home.why.advantage1.description": "Over 40 years of activity in construction and real estate in Senegal, with thousands of homes delivered.",
  "home.why.advantage1.title": "Recognized experience",
  "home.why.advantage2.description": "Comprehensive expertise across the full construction cycle: studies, execution, servicing, marketing.",
  "home.why.advantage2.title": "Project mastery",
  "home.why.advantage3.description": "Modern low-carbon footprint techniques and local workforce training.",
  "home.why.advantage3.title": "Sustainable responsibility",
  "home.why.advantage4.description": "BIM, construction ERP, Geoplast® formwork, precast factory… SOCABEG invests in modernity.",
  "home.why.advantage4.title": "Technical innovation",
  "home.why.advantage5.description": "Tivaouane Peulh, HLM Castor, Darou Salam, Cité IPRES… projects that transform the city.",
  "home.why.advantage5.title": "Iconic projects",
  "home.why.advantage6.description": "100% Senegalese human-scale company, close to its clients and their needs.",
  "home.why.advantage6.title": "Trust and proximity",
  "home.why.description": "Discover the many advantages that make SOCABEG a trusted partner for your projects.",
  "home.why.highlight": "OUR ADDED VALUE",
  "home.why.innovation.description": "We continuously innovate to offer cutting-edge solutions to our clients.",
  "home.why.innovation.title": "Innovation",
  "home.why.quality.description": "We commit to providing high-quality services that meet the highest standards.",
  "home.why.quality.title": "Quality",
  "home.why.sustainability.description": "We integrate sustainable development into all our projects for a better future.",
  "home.why.sustainability.title": "Sustainability",
  "home.why.title": "WHY CHOOSE US",
  "home.why.trust.description": "We build lasting relationships based on trust and transparency with our clients.",
  "home.why.trust.title": "Trust",

  // =========================
  // ABOUT
  // =========================
  "about.engagement.mission.paragraph1": "Provide high-quality construction services to meet our clients' needs while respecting safety, sustainability and efficiency standards.",
  "about.engagement.mission.paragraph2": "We aim to carry out projects that positively contribute to the development of communities and the environment in which we operate.",
  "about.engagement.mission.title": "Mission",
  "about.engagement.objectives.paragraph1": "Increase access to affordable housing: contribute to solving the housing crisis by providing affordable homes for low-income people.",
  "about.engagement.objectives.paragraph2": "Improve the quality and sustainability of housing: build high-quality, durable and energy-efficient homes to ensure residents' well-being and reduce environmental impact.",
  "about.engagement.objectives.title": "Objectives",
  "about.engagement.paragraph1": "SOCABEG has thus contributed to the development of new urban areas by building several thousand homes intended for a large part of the Senegalese population with modest incomes.",
  "about.engagement.paragraph2": "Our expertise, industrial capacity and operational rigor enable us to develop high-quality, structuring and sustainable projects that meet the needs of a rapidly evolving market.",
  "about.engagement.paragraph3": "By mastering the entire value chain from land to turnkey delivery, we offer accessible and reliable real estate solutions. Our performance relies on continuous investments in innovation, process industrialization, and a latest-generation equipment fleet, allowing us to produce up to 100 homes in 6 months.",
  "about.engagement.paragraph4": "Committed alongside local territories, SOCABEG promotes local employment and carries out strong social responsibility actions, particularly in community sports and support for national initiatives. Indeed, SOCABEG has long sponsored neighborhood championships (Navétanes) and the Lionnes, Senegal's Women's National Basketball Team, African Champions.",
  "about.engagement.paragraph5": "We thank our clients and partners for the trust they place in us, as well as our teams for the professionalism and mobilization they demonstrate every day through the projects, allowing us to continue our mission: build sustainably, create value and support Senegal's urban transformation.",
  "about.engagement.quote": "FOR 40 YEARS, SOCABEG HAS ESTABLISHED ITSELF AS A MAJOR PLAYER IN CONSTRUCTION AND REAL ESTATE DEVELOPMENT IN SENEGAL AND IS COMMITTED ALONGSIDE SENEGALESE PEOPLE TO ENABLE THEM TO FULFILL THE DREAM OF BECOMING HOMEOWNERS",
  "about.engagement.subtitle": "OUR COMMITMENT",
  "about.engagement.title": "OUR COMMITMENT",
  "about.engagement.vision.paragraph1": "Be recognized as the reference company in the construction sector, offering innovative and sustainable solutions for building essential infrastructure in Dakar and internationally.",
  "about.engagement.vision.paragraph2": "We aspire to develop strong partnerships with our clients, attract and develop the best talent, and become a major player in large-scale projects that shape the future of our society.",
  "about.engagement.vision.title": "Vision",
  "about.foundations.title": "Our foundations",
  "about.hero.subtitle": "Our story is the imprint of passion and determination for over 30 years.",
  "about.hero.title": "Our History,\nour principles, our outlook ...",
  "about.history.event1.description": "Construction and real estate development.",
  "about.history.event1.title": "Creation of SOCABEG SA",
  "about.history.event1.year": "June 1986",
  "about.history.event2.description": "Construction of 124 homes in Rufisque and many other projects in Dakar and surroundings.",
  "about.history.event2.title": "First construction sites",
  "about.history.event2.year": "1988",
  "about.history.event3.description": "Diversification and development of real estate and infrastructure projects between 1989 and 2000.",
  "about.history.event3.title": "Development of varied projects",
  "about.history.event3.year": "1989 - 2000",
  "about.history.event4.description": "Expansion of our activities into mining exploration.",
  "about.history.event4.title": "Creation of SOCABEG Mining",
  "about.history.event4.year": "2015",
  "about.history.event5.description": "Construction and commissioning of the head office.",
  "about.history.event5.title": "Head office inauguration",
  "about.history.event5.year": "2017",
  "about.history.event6.description": "Launch of the Balena program, first high-end project.",
  "about.history.event6.title": "Creation of Keur Invest subsidiary",
  "about.history.event6.year": "2018",
  "about.history.event7.description": "Construction of over 500 homes and completion of land servicing projects.",
  "about.history.event7.title": "Major real estate projects",
  "about.history.event7.year": "2019 to present",
  "about.history.event8.description": "Acquisition of a new concrete batching plant in Almadies, strengthening our production capacity.",
  "about.history.event8.title": "New concrete batching plant - Almadies",
  "about.history.event8.year": "2025",
  "about.history.events.balena.description": "Start of the high-end real estate project Le Clos des Balena",
  "about.history.events.balena.title": "Le Clos des Balena",
  "about.history.events.creation.description": "Construction and Real Estate Development",
  "about.history.events.creation.title": "Creation of SOCABEG SA",
  "about.history.events.expansion.description": "Expansion of activities in public works and institutional buildings",
  "about.history.events.expansion.title": "Activity expansion",
  "about.history.events.keurinvest.description": "Creation of the KEURINVEST subsidiary for real estate development",
  "about.history.events.keurinvest.title": "KEURINVEST",
  "about.history.events.materiels.description": "Acquisition of new heavy equipment and specialization in construction",
  "about.history.events.materiels.title": "Equipment acquisition",
  "about.history.events.mining.description": "Creation of the SOCABEG Mining branch for the mining sector",
  "about.history.events.mining.title": "SOCABEG Mining",
  "about.history.events.premiers.description": "Completion of first housing sites in Senegal",
  "about.history.events.premiers.title": "First sites",
  "about.history.events.residentiels.description": "Launch of several residential projects in Dakar and its suburbs",
  "about.history.events.residentiels.title": "Residential projects",
  "about.history.highlight": "OUR JOURNEY SINCE 1986",
  "about.history.timeline.1980": "1980s - 1990s",
  "about.history.timeline.1983": "1986",
  "about.history.timeline.2000s": "2000s",
  "about.history.timeline.2010": "2010",
  "about.history.timeline.2015": "2015",
  "about.history.timeline.2018": "2018",
  "about.history.timeline.2020": "2020",
  "about.history.title": "HISTORY",
  "about.organization.description1": "Public limited company with a capital of 1 billion CFA francs created in 1986, SOCABEG aims to improve the living environment of Senegalese people by offering innovative, high-quality real estate programs at attractive and adapted prices. Its ambition has always been to combine quality construction with accessible cost.",
  "about.organization.description2": "The SOCABEG organization is structured around several skill centers operating in perfect synergy. This organization into different directions and services allows the company to reach the level of expertise necessary to provide an appropriate response to each client's expectations.",
  "about.organization.structure.paragraph1": "Under the responsibility of General Management, supported by an Executive Committee and relying on a Board of Directors composed of professionals with long and rich experience, in order to:",
  "about.organization.structure.point1": "generate fruitful exchanges and better cross experiences and expertise,",
  "about.organization.structure.point2": "be as close as possible to our clients' expectations, and guarantee the quality and performance of our projects.",
  "about.organization.tagline": "Proud builders of today, creators of tomorrow's heritage",
  "about.organization.title": "ORGANIZATION",
  "about.values.caring.description": "We take care of our clients, our employees and the communities in which we operate, acting with respect, empathy and responsibility.",
  "about.values.caring.title": "CARING",
  "about.values.description1": "They guide us in every decision, every project and every interaction. They reflect our corporate culture and influence the way we interact with our employees.",
  "about.values.description2": "These core values are the foundation on which our commitment to excellence and integrity rests. We firmly believe that transparency and open communication strengthen trust and promote a harmonious work environment. By cultivating a spirit of innovation and collaboration, we aim to inspire and motivate every team member to give their best. Together, we can overcome challenges, celebrate successes and continue to grow while remaining true to our principles.",
  "about.values.engagement.description": "We fully commit to every project, with passion and determination, to exceed our clients' expectations.",
  "about.values.engagement.title": "COMMITMENT",
  "about.values.mainTitle": "OUR VALUES ARE AT THE HEART OF EVERYTHING WE DO",
  "about.values.quality.description": "We aim for excellence in everything we do, respecting the highest standards and seeking continuous improvement.",
  "about.values.quality.title": "QUALITY",
  "about.values.sharing.description": "We value sharing knowledge, experiences and resources to create a collaborative culture that benefits all our projects and partners.",
  "about.values.sharing.title": "SHARING",
  "about.values.solution.description": "We are solution-oriented, always seeking to resolve challenges with creativity and efficiency to guarantee the success of every project.",
  "about.values.solution.title": "SOLUTION-ORIENTED",
  "about.values.title": "OUR VALUES",

  // =========================
  // REAL ESTATE
  // =========================
  "realEstate.areaName": "Location",
  "realEstate.backToList": "Back to list",
  "realEstate.budgetPlaceholder": "Budget in FCFA",
  "realEstate.hero.subtitle": "Discover a wide selection of properties suited to your future acquisitions.",
  "realEstate.hero.title": "We build living spaces that endure over time ...",
  "realEstate.location": "Location",
  "realEstate.locations.almadies": "Almadies",
  "realEstate.locations.almadies2": "Almadies 2",
  "realEstate.locations.hlm5": "HLM 5",
  "realEstate.locations.ndiakhirate": "Ndiakhirate",
  "realEstate.locations.tivaouanePeulh": "Tivaouane Peulh",
  "realEstate.maxBudget": "Maximum budget",
  "realEstate.programsTitle": "Our real estate programs",
  "realEstate.propertyType": "Property type",
  "realEstate.propertyTypes.apartment": "Apartment",
  "realEstate.propertyTypes.commercial": "Shops",
  "realEstate.propertyTypes.house": "Villa",
  "realEstate.propertyTypes.housing": "Housing",
  "realEstate.propertyTypes.land": "Land",
  "realEstate.propertyTypes.socialHousing": "Social housing",
  "realEstate.searchButton": "Search",
  "realEstate.searchDescription": "Houses, commercial premises, land or social housing… Find the program that best suits you…",
  "realEstate.searchError": "Please fill in at least one field to perform a search.",
  "realEstate.searchTitle": "SEARCH FOR A PROPERTY",
  "realEstate.selectLocation": "Choose a location",
  "realEstate.selectPropertyType": "Choose a property type",
  "realEstate.subtitle": "Your trusted partner for innovative and sustainable real estate projects",
  "realEstate.viewAllProperties": "View all our properties",

  // =========================
  // CONSTRUCTION
  // =========================
  "construction.amenagement.cta": "Request a quote",
  "construction.amenagement.imageAlt": "Urban space developed by SOCABEG",
  "construction.amenagement.paragraph1": "SOCABEG has a dedicated division for the development of urban or rural spaces.",
  "construction.amenagement.paragraph2": "Since its foundation, SOCABEG has demonstrated its expertise in developing entire neighborhoods and public spaces.",
  "construction.amenagement.paragraph3": "The company is committed to sustainable initiatives, integrating green technologies and environmentally friendly materials.",
  "construction.amenagement.paragraph4": "Our team offers tailor-made solutions that combine aesthetics and practicality for economic and social development.",
  "construction.amenagement.paragraph5": "SOCABEG aspires to be a model of social and environmental responsibility in Senegal.",
  "construction.amenagement.subtitle": "Human-scale company, we are at your disposal to design, collaborate and build your future home together.",
  "construction.amenagement.title": "Land Development",
  "construction.building.cta": "Request a quote",
  "construction.building.imageAlt": "Building construction site",
  "construction.building.paragraph1": "Recognized as a leader in housing construction in Senegal, SOCABEG has built a solid reputation through its expertise, dedication and mastery of building.",
  "construction.building.paragraph2": "From project definition to delivery, including design and construction monitoring, our technicians ensure smooth progress in complete safety, before, during and after handover.",
  "construction.building.paragraph3": "We build structures with our know-how and a clear vision: offices, warehouses, shops, commercial and industrial buildings, sports complexes, etc.",
  "construction.building.paragraph4": "With an approach focused on quality and innovation, SOCABEG is committed to meeting the varied needs of its clients while respecting environmental and societal standards.",
  "construction.building.subtitle": "Comprehensive solutions and tailor-made support from A to Z for the success of your projects.",
  "construction.building.title": "Buildings",
  "construction.civilEngineering.cta": "Request a quote",
  "construction.civilEngineering.imageAlt": "Civil engineering site",
  "construction.civilEngineering.paragraph1": "SOCABEG includes a dedicated civil engineering division. Our engineers implement solutions for all types of projects: roads, bridges, dams, canals, tunnels, etc.",
  "construction.civilEngineering.paragraph2": "Thanks to our investments in new technologies and equipment, we have been able to automate the construction process and achieve significant productivity gains.",
  "construction.civilEngineering.paragraph3": "Our services include: technical studies, design, execution and renovation of infrastructure.",
  "construction.civilEngineering.paragraph4": "We guarantee high-quality results with particular attention to the durability and safety of our structures.",
  "construction.civilEngineering.paragraph5": "We collaborate with our partners for constructions that meet community needs.",
  "construction.civilEngineering.subtitle": "Over 40 years of experience at your service, with assistance that meets BTP sector requirements",
  "construction.civilEngineering.title": "Civil Engineering",
  "construction.hero.subtitle": "Expertise in building, civil engineering and land development",
  "construction.hero.title": "At the heart of construction\nto offer you a better living environment",

  // =========================
  // MINING
  // =========================
  "mining.activity.geographic.content": "The “NDINDY” project is located in a strategic position:",
  "mining.activity.geographic.point1": "Surrounded by the Baobab Mining small mine and exploration permits of AIG and ICS.",
  "mining.activity.geographic.point2": "Less than ten kilometers from the Gadde Bissik small mine.",
  "mining.activity.geographic.point3": "Proximity to port and rail infrastructure for export.",
  "mining.activity.geographic.title": "Geographic advantage",
  "mining.activity.objective": "Our objective:",
  "mining.activity.objectiveText": "Develop partnerships to provide long-term sustainable benefits, based on a model of shared responsibility and empowerment, to ensure these benefits last beyond the mine's life.",
  "mining.activity.steps.exploration.text": "We conduct exploration activities to identify and evaluate potential mineral deposits using geological and geophysical techniques.",
  "mining.activity.steps.exploration.title": "Deposit exploration",
  "mining.activity.steps.mining.text": "We extract minerals and ores efficiently and responsibly, while maximizing economic returns.",
  "mining.activity.steps.mining.title": "Mining exploitation",
  "mining.activity.steps.processing.text": "We implement processing methods to separate valuable minerals from raw ore and produce marketable concentrates or finished products.",
  "mining.activity.steps.processing.title": "Ore processing",
  "mining.activity.subtitle": "ACTIVITY IN BRIEF…",
  "mining.activity.title": "Our mining activity",
  "mining.advantages.title": "Our strengths",
  "mining.contact.address": "Fann Hock, opposite the Supreme Court",
  "mining.contact.email": "mining@socabeg.sn",
  "mining.contact.title": "CONTACT US",
  "mining.contact.website": "www.socabeg.com",
  "mining.esg.point1": "Impact study validated (June 2023), final approval expected Q4 2025",
  "mining.esg.point2": "Social investments: schools, health, infrastructure, local employment",
  "mining.esg.title": "ESG COMMITMENT",
  "mining.hero.subtitle": "Expertise and sustainable solutions for the mining industry",
  "mining.hero.title": "Mining innovation: Impactful actions transforming the sector for a more sustainable future...",
  "mining.market.point1": "Strong global demand (agriculture, food security)",
  "mining.market.point2": "Target clients: fertilizer producers, international traders",
  "mining.market.title": "MARKET",
  "mining.phosphates.location.description": "Project located in Senegal (Thiès Region), 170 km from Dakar port.",
  "mining.phosphates.location.title": "LOCATION",
  "mining.phosphates.production.point1": "Open-pit mine of 1.5 Mt ore/year → 600,000 t phosphate concentrate (32% P₂O₅)",
  "mining.phosphates.production.point2": "Process: dry screening (reduced CAPEX/OPEX)",
  "mining.phosphates.production.point3": "Planned start-up: 2027",
  "mining.phosphates.production.point4": "Future phases: mine extension (256 km²), fertilizer plant.",
  "mining.phosphates.production.title": "PRODUCTION",
  "mining.phosphates.resources.point1": "Small mine license (5 km², 2024) – extension to 256 km² in progress",
  "mining.phosphates.resources.point2": "109 Mt inferred resources, including 37.3 Mt at 16.7% P₂O₅ (JORC 2012, 10% cutoff)",
  "mining.phosphates.resources.point3": "Mine life: 10 years (Phase 1), extendable to 20+ years.",
  "mining.phosphates.resources.title": "RESOURCES",
  "mining.phosphates.subtitle": "A STRATEGIC MINING OPPORTUNITY IN SENEGAL",
  "mining.phosphates.title": "OUR NIAKHAL PHOSPHATES PROJECT",
  "mining.presentation.about.paragraph1": "SOCABEG Mining is a Senegalese mining exploration company, subsidiary of the SOCABEG group. It specializes in the acquisition, exploration and development of mining properties in Senegal.",
  "mining.presentation.about.paragraph2": "The project is located in Senegal in the Diourbel region, which hosts significant phosphate resources and continues to attract major mining companies, including Baobab Mining of the Avenira group, already in production via its Gadde Bissik small mine.",
  "mining.presentation.blue.paragraph1": "SOCABEG Mining currently holds 100% of the Ndindy phosphate project shares. The Ndindy phosphate exploration permit is located 170 km from Dakar and 27 km from the city of Diourbel.",
  "mining.presentation.blue.paragraph2": "The phosphate exploration perimeter covers an area of 871 km² and is bounded to the north and west by the Baobab Mining exploration permit, to the northeast by the Kébémère permit of Africa Investment Group (AIG) and to the south by the ICS Gossas permit.",
  "mining.presentation.blue.paragraph3": "In March and April 2018, SOCABEG Mining completed an initial RC drilling exploration program of over 1,400 linear meters on the Ndindy permit.",
  "mining.presentation.subtitle": "Sustainable mining creating value",
  "mining.presentation.title": "Presentation of SOCABEG Mining",
  "mining.whyInvest.point1": "Evolving high-grade resources",
  "mining.whyInvest.point2": "High profitability & quick return",
  "mining.whyInvest.point3": "Stable regulatory environment",
  "mining.whyInvest.point4": "Strong ESG commitment",
  "mining.whyInvest.title": "WHY INVEST?",

  // =========================
  // CAREERS – tous les jobs traduits
  // =========================
  "careers.applyNow": "Apply now",
  "careers.backToJobs": "Back to offers",
  "careers.job1.company": "SOCABEG",
  "careers.job1.description": "We are looking for an experienced site manager to supervise our construction projects. You will be responsible for team coordination and proper progress of the works.",
  "careers.job1.location": "Dakar",
  "careers.job1.requirements": [
    "Degree in civil engineering or equivalent",
    "Minimum 5 years of experience as site manager",
    "Excellent team management skills",
    "Mastery of on-site safety standards"
  ],
  "careers.job1.responsibilities": [
    "Supervise all works on the site",
    "Coordinate the various trades",
    "Ensure compliance with deadlines and budgets",
    "Ensure the quality of the work carried out"
  ],
  "careers.job1.title": "Site Manager",
  "careers.job1.type": "Permanent contract (CDI)",
  "careers.job10.company": "SOCABEG",
  "careers.job10.description": "We are looking for an on-site plumber to carry out sanitary and plumbing installations on our construction projects. You will be responsible for setting up water supply and drainage networks.",
  "careers.job10.location": "Dakar",
  "careers.job10.requirements": [
    "CAP or BEP in plumbing",
    "Minimum 3 years of experience in on-site plumbing",
    "Knowledge of welding and assembly techniques",
    "Mastery of sanitary standards"
  ],
  "careers.job10.responsibilities": [
    "Install water supply networks",
    "Set up drainage systems",
    "Install sanitary appliances",
    "Perform leak-tightness tests"
  ],
  "careers.job10.title": "On-site Plumber",
  "careers.job10.type": "Permanent contract (CDI)",
  "careers.job11.company": "SOCABEG",
  "careers.job11.description": "We are looking for a general accountant to ensure the keeping and reliability of SOCABEG group's accounts.",
  "careers.job11.location": "Dakar",
  "careers.job11.requirements": [
    "BAC+3 in accounting, finance or equivalent",
    "Minimum 3 years of experience in general accounting",
    "Mastery of OHADA accounting standards",
    "Excellent command of Excel and accounting software"
  ],
  "careers.job11.responsibilities": [
    "Handle and control accounting entries",
    "Prepare tax and social declarations",
    "Participate in the preparation of financial statements",
    "Ensure compliance of entries with internal procedures"
  ],
  "careers.job11.title": "General Accountant",
  "careers.job11.type": "Permanent contract (CDI)",
  "careers.job12.company": "SOCABEG",
  "careers.job12.description": "You manage the supplier cycle: invoice processing, reconciliations and payment follow-up.",
  "careers.job12.location": "Dakar",
  "careers.job12.requirements": [
    "BAC+2/3 in accounting",
    "Experience in a similar position preferred",
    "Rigor, attention to detail and respect for deadlines",
    "Good command of Excel and office tools"
  ],
  "careers.job12.responsibilities": [
    "Enter and control supplier invoices",
    "Perform reconciliations with purchase orders and delivery notes",
    "Prepare payment campaigns",
    "Manage supplier reminders and disputes"
  ],
  "careers.job12.title": "Accounts Payable Accountant",
  "careers.job12.type": "Permanent contract (CDI)",
  "careers.job13.company": "SOCABEG",
  "careers.job13.description": "Accounting assistant internship to support the team in daily accounting tasks.",
  "careers.job13.location": "Dakar",
  "careers.job13.requirements": [
    "Student in accounting, finance or management",
    "Good command of Excel",
    "Desire to learn and work in a team",
    "Organizational skills and confidentiality"
  ],
  "careers.job13.responsibilities": [
    "Participate in entering accounting documents",
    "Assist with bank reconciliations",
    "Classify and archive accounting documents",
    "Contribute to monthly closing tasks"
  ],
  "careers.job13.title": "Accounting Assistant (Internship)",
  "careers.job13.type": "Internship",
  "careers.job14.company": "SOCABEG",
  "careers.job14.description": "We are looking for a management controller to steer the financial performance of our projects and subsidiaries.",
  "careers.job14.location": "Dakar",
  "careers.job14.requirements": [
    "BAC+4/5 in management control, finance or business school",
    "Minimum 3 years of experience in management control",
    "Excellent command of Excel and reporting tools",
    "Analytical skills and synthesis ability"
  ],
  "careers.job14.responsibilities": [
    "Prepare and monitor budgets",
    "Analyze variances between forecast and actual",
    "Produce dashboards and performance indicators",
    "Support operational departments in decision-making"
  ],
  "careers.job14.title": "Management Controller",
  "careers.job14.type": "Permanent contract (CDI)",
  "careers.job15.company": "SOCABEG",
  "careers.job15.description": "You carry out financial analyses and profitability studies for group projects.",
  "careers.job15.location": "Dakar",
  "careers.job15.requirements": [
    "BAC+4/5 in finance, audit or business school",
    "Excellent financial analysis skills",
    "Mastery of Excel and modeling tools",
    "Good knowledge of financial statements"
  ],
  "careers.job15.responsibilities": [
    "Analyze project and investment profitability",
    "Prepare financial notes and reports for management",
    "Participate in cash flow forecasts and financing plans",
    "Contribute to improving analysis tools"
  ],
  "careers.job15.title": "Financial Analyst",
  "careers.job15.type": "Permanent contract (CDI)",
  "careers.job16.company": "SOCABEG",
  "careers.job16.description": "You manage group treasury, cash flow monitoring and bank relations.",
  "careers.job16.location": "Dakar",
  "careers.job16.requirements": [
    "BAC+3/5 in finance or accounting",
    "Experience in treasury or cash management",
    "Mastery of Excel and online banking tools",
    "Rigor, reliability and sense of confidentiality"
  ],
  "careers.job16.responsibilities": [
    "Monitor daily cash positions",
    "Prepare cash flow forecasts",
    "Optimize payment and collection flows",
    "Ensure follow-up of relations with banking partners"
  ],
  "careers.job16.title": "Treasurer",
  "careers.job16.type": "Permanent contract (CDI)",
  "careers.job17.company": "SOCABEG",
  "careers.job17.description": "You are responsible for monitoring client collections and recovery actions.",
  "careers.job17.location": "Dakar",
  "careers.job17.requirements": [
    "BAC+2/3 in accounting, finance or commercial management",
    "Good interpersonal skills and negotiation ability",
    "Organization and perseverance",
    "Mastery of office tools"
  ],
  "careers.job17.responsibilities": [
    "Monitor client balances and payment delays",
    "Remind clients by phone and in writing",
    "Propose payment plans when necessary",
    "Update client files and recovery reporting"
  ],
  "careers.job17.title": "Recovery Officer",
  "careers.job17.type": "Fixed-term contract (CDD)",
  "careers.job18.company": "SOCABEG",
  "careers.job18.description": "We are looking for an HR manager to manage all human resources of the company. You will be responsible for recruitment, training and administrative staff management.",
  "careers.job18.location": "Dakar",
  "careers.job18.requirements": [
    "Higher education in human resources or management",
    "Minimum 5 years of experience in a similar position",
    "Knowledge of Senegalese labor law",
    "Conflict management and leadership skills"
  ],
  "careers.job18.responsibilities": [
    "Manage recruitment and onboarding of new employees",
    "Handle administrative staff management",
    "Develop and implement training plans",
    "Ensure compliance with labor law and collective agreements"
  ],
  "careers.job18.title": "HR Manager",
  "careers.job18.type": "Permanent contract (CDI)",
  "careers.job19.company": "SOCABEG",
  "careers.job19.description": "We are looking for a client accountant to manage invoicing and payment monitoring. You will be responsible for managing client accounts and recovery.",
  "careers.job19.location": "Dakar",
  "careers.job19.requirements": [
    "Training in accounting or management",
    "Minimum 3 years of experience in a similar position",
    "Mastery of accounting software",
    "Rigor and organizational skills"
  ],
  "careers.job19.responsibilities": [
    "Issue client invoices",
    "Monitor payments",
    "Manage reminders and recovery",
    "Prepare client financial reports"
  ],
  "careers.job19.title": "Accounts Receivable Accountant",
  "careers.job19.type": "Permanent contract (CDI)",
  "careers.job2.company": "SOCABEG",
  "careers.job2.description": "We are looking for an assistant works supervisor to assist our team in site management. You will participate in planning and monitoring construction projects.",
  "careers.job2.location": "Dakar",
  "careers.job2.requirements": [
    "Training in civil engineering or building",
    "2 to 3 years of experience in similar positions",
    "Good technical knowledge in construction",
    "Ability to read and interpret plans"
  ],
  "careers.job2.responsibilities": [
    "Assist the main works supervisor",
    "Monitor work progress",
    "Coordinate subcontractor interventions",
    "Participate in site meetings"
  ],
  "careers.job2.title": "Assistant Works Supervisor",
  "careers.job2.type": "Permanent contract (CDI)",
  "careers.job20.company": "SOCABEG",
  "careers.job20.description": "We are looking for a supplier accountant to manage supplier invoices and payments. You will be responsible for processing invoices and monitoring due dates.",
  "careers.job20.location": "Dakar",
  "careers.job20.requirements": [
    "Training in accounting or management",
    "Minimum 3 years of experience in a similar position",
    "Mastery of accounting software",
    "Rigor and organizational skills"
  ],
  "careers.job20.responsibilities": [
    "Process supplier invoices",
    "Prepare payments",
    "Monitor due dates",
    "Manage supplier disputes"
  ],
  "careers.job20.title": "Accounts Payable Accountant",
  "careers.job20.type": "Permanent contract (CDI)",
  "careers.job3.company": "SOCABEG",
  "careers.job3.description": "We are looking for a topographer/surveyor to carry out surveys and setting out on our various sites. You will be responsible for ensuring the accuracy of measurements and plans.",
  "careers.job3.location": "Thiès",
  "careers.job3.requirements": [
    "Degree in topography or expert surveyor",
    "Minimum 3 years of experience in the field",
    "Mastery of measuring instruments and specialized software",
    "Rigor and precision in work"
  ],
  "careers.job3.responsibilities": [
    "Carry out topographic surveys",
    "Perform setting out on site",
    "Prepare plans and technical documents",
    "Monitor terrain modifications"
  ],
  "careers.job3.title": "Topographer / Surveyor",
  "careers.job3.type": "Permanent contract (CDI)",
  "careers.job4.company": "SOCABEG",
  "careers.job4.description": "We are looking for a design drafter to produce technical plans for our construction projects. You will work closely with our engineers and architects.",
  "careers.job4.location": "Dakar",
  "careers.job4.requirements": [
    "Training in technical drawing or civil engineering",
    "Mastery of CAD/CAE software (AutoCAD, Revit)",
    "Minimum 2 years of experience in a similar position",
    "Good knowledge of construction standards"
  ],
  "careers.job4.responsibilities": [
    "Produce execution plans",
    "Participate in technical studies",
    "Make modifications requested by clients",
    "Ensure consistency of technical documents"
  ],
  "careers.job4.title": "Design Drafter",
  "careers.job4.type": "Fixed-term contract (CDD)",
  "careers.job5.company": "SOCABEG",
  "careers.job5.description": "We are looking for a building technician to ensure technical monitoring of our sites. You will be responsible for monitoring work quality and compliance with standards.",
  "careers.job5.location": "Dakar",
  "careers.job5.requirements": [
    "BTS or DUT in civil engineering or building",
    "Minimum 2 years of experience in the sector",
    "Knowledge of construction techniques",
    "Ability to read and interpret technical plans"
  ],
  "careers.job5.responsibilities": [
    "Control work quality",
    "Verify compliance with plans and standards",
    "Write technical reports",
    "Participate in site meetings"
  ],
  "careers.job5.title": "Building Technician",
  "careers.job5.type": "Fixed-term contract (CDD)",
  "careers.job6.company": "SOCABEG",
  "careers.job6.description": "We are looking for a civil engineering technician to participate in our infrastructure projects. You will be involved in the execution and monitoring of civil engineering works.",
  "careers.job6.location": "Saint-Louis",
  "careers.job6.requirements": [
    "DUT or BTS in civil engineering",
    "Minimum 2 years of experience in the field",
    "Knowledge of construction techniques",
    "Ability to work in a team"
  ],
  "careers.job6.responsibilities": [
    "Participate in technical studies",
    "Monitor work execution",
    "Control structure quality",
    "Write monitoring reports"
  ],
  "careers.job6.title": "Civil Engineering Technician",
  "careers.job6.type": "Fixed-term contract (CDD)",
  "careers.job7.company": "SOCABEG",
  "careers.job7.description": "We are looking for a qualified mason to join our construction team. You will be responsible for carrying out masonry works on our various sites.",
  "careers.job7.location": "Dakar",
  "careers.job7.requirements": [
    "CAP or BEP in masonry",
    "Minimum 2 years of experience in the trade",
    "Mastery of masonry techniques",
    "Compliance with safety standards"
  ],
  "careers.job7.responsibilities": [
    "Carry out masonry works",
    "Build walls, partitions and foundations",
    "Apply plaster and finishes",
    "Respect plans and instructions"
  ],
  "careers.job7.title": "Mason",
  "careers.job7.type": "Internship",
  "careers.job8.company": "SOCABEG",
  "careers.job8.description": "We are looking for a formworker/steel fixer for our construction sites. You will be responsible for carrying out formwork and placing metal reinforcements.",
  "careers.job8.location": "Dakar",
  "careers.job8.requirements": [
    "CAP or BEP in construction",
    "Minimum 2 years of experience in formwork and steel fixing",
    "Knowledge of formwork techniques",
    "Ability to read reinforcement plans"
  ],
  "careers.job8.responsibilities": [
    "Carry out formwork according to plans",
    "Place metal reinforcements",
    "Ensure work quality",
    "Respect safety standards"
  ],
  "careers.job8.title": "Formworker / Steel Fixer",
  "careers.job8.type": "Internship",
  "careers.job9.company": "SOCABEG",
  "careers.job9.description": "We are looking for an on-site electrician to carry out electrical installations on our construction projects. You will be responsible for setting up and maintaining electrical installations.",
  "careers.job9.location": "Thiès",
  "careers.job9.requirements": [
    "CAP or BEP in electricity",
    "Up-to-date electrical authorization",
    "Minimum 3 years of experience in on-site electricity",
    "Knowledge of electrical standards"
  ],
  "careers.job9.responsibilities": [
    "Carry out electrical installations",
    "Perform connections and hook-ups",
    "Maintain equipment",
    "Respect safety standards"
  ],
  "careers.job9.title": "On-site Electrician",
  "careers.job9.type": "Internship",
  "careers.jobDetails": "Job description",
  "careers.jobListings.title": "Job offers",
  "careers.missions": "Responsibilities",
  "careers.noResults": "No job offer matches your search.",
  "careers.profile": "Required profile",
  "careers.results": "results",
  "careers.search.allTypes": "All types",
  "careers.search.button": "SEARCH JOB OFFERS",
  "careers.search.internship": "Internship",
  "careers.search.jobTitle": "Job title",
  "careers.search.location": "Location",
  "careers.search.permanent": "Permanent (CDI)",
  "careers.search.temporary": "Fixed-term (CDD)",
  "careers.subtitle": "Discover our career opportunities and contribute to shaping Senegal's future",
  "careers.title": "JOIN US",
  "careers.viewDetails": "View details",

  // =========================
  // PROJECTS – tous les projets traduits
  // =========================
  "projects.almadies.address": "Les Terrasses des Almadies",
  "projects.almadies.naturePapier": "Land title (TF)",
  "projects.almadies.statut": "Serviced",
  "projects.almadies.description": "Serviced plots for sale in the heart of a dynamic and sought-after neighborhood. Take advantage of an exceptional investment opportunity in one of Dakar's most prestigious areas. These plots offer an ideal setting to build your dream home or carry out a profitable real estate project. Don't miss this unique opportunity to settle in a fast-growing environment with all amenities nearby.",
  "projects.almadies.features": [
    "Prestigious neighborhood",
    "Full servicing",
    "Land title",
    "Proximity to amenities"
  ],
  "projects.almadies.programPlus": "Highlights of the offer",
  "projects.almadies.booking.deposit": "Cash purchase",
  "projects.almadies.booking.balance": "",
  "projects.almadies.booking.fees": "",
  "projects.almadies.booking.financing": "Bank financing possible",
  "projects.almadies.localisation": "Almadies",
  "projects.almadies.price": "800,000 FCFA / m²",
  "projects.almadies.title": "Serviced plots – Almadies",
  "projects.almadies.type": "Plots – 250 m²",
  "projects.almadies2.address": "Almadies 2",
  "projects.almadies2.naturePapier": "Land title (TF)",
  "projects.almadies2.statut": "Serviced",
  "projects.almadies2.description": "Serviced plots for sale in the heart of a dynamic and sought-after neighborhood. Take advantage of an exceptional investment opportunity in one of Dakar's most prestigious areas. These plots offer an ideal setting to build your dream home or carry out a profitable real estate project. Don't miss this unique opportunity to settle in a fast-growing environment with all amenities nearby.",
  "projects.almadies2.floor": "G+1",
  "projects.almadies2.localisation": "Almadies 2",
  "projects.almadies2.price": "25,000,000 FCFA",
  "projects.almadies2.booking.deposit": "Cash purchase",
  "projects.almadies2.booking.balance": "",
  "projects.almadies2.booking.fees": "",
  "projects.almadies2.booking.financing": "Bank financing possible",
  "projects.almadies2.title": "Serviced plots – Almadies 2",
  "projects.almadies2.type": "Plots – 150 m²",
  "projects.balena.address": "Le Clos des Balena",
  "projects.balena.description": "Located in the upscale Almadies district, this exceptional real estate program combines luxury and sustainability. The spacious 500 m² villas offer an unobstructed view of the ocean, with high-end finishes and modern amenities.",
  "projects.balena.features": [
    "Private swimming pool",
    "Garden",
    "2 kitchens (African and American)",
    "Accessible site close to amenities",
    "Modern architecture",
    "Generous spaces"
  ],
  "projects.balena.programPlus": "Program highlights",
  "projects.balena.booking.fees": "",
  "projects.balena.booking.deposit": "VEFA mode - 30% deposit on reservation",
  "projects.balena.booking.balance": "Balance released according to work progress",
  "projects.balena.booking.financing": "Bank financing possible",
  "projects.balena.floor": "G+1",
  "projects.balena.localisation": "Almadies",
  "projects.balena.price": "CONTACT US",
  "projects.balena.reservationConditions": "VEFA mode - 30% deposit on reservation\nBalance released according to work progress\nBank financing possible",
  "projects.balena.title": "Balena Residences – Almadies",
  "projects.balena.type": "G+1 Villa – 500 m²",
  "projects.contactUs": "Contact us",
  "projects.description": "Housing, commercial spaces or serviced plots… Discover the program that best suits you.",
  "projects.discoverMore": "Discover more",
  "projects.highlight": "FEATURED PROGRAMS",
  "projects.hlm.address": "DAROU SALAM Shopping Center",
  "projects.hlm.description": "Ideally located in the dynamic HLM 5 district, these 105 commercial units of 12 m² each represent a unique investment opportunity. With high foot traffic and optimal accessibility, these spaces are perfect for traders and entrepreneurs.",
  "projects.hlm.features": [
    "Strategic location",
    "Easy access",
    "24/7 security",
    "Toilets",
    "Water and electricity",
    "Street-facing shop window"
  ],
  "projects.hlm.programPlus": "Program highlights",
  "projects.hlm.booking.fees": "",
  "projects.hlm.booking.deposit": "30% deposit on reservation",
  "projects.hlm.booking.balance": "Balance on key handover",
  "projects.hlm.booking.financing": "Bank financing possible",
  "projects.hlm.floor": "Ground floor",
  "projects.hlm.localisation": "HLM 5",
  "projects.hlm.price": "25,000,000 FCFA",
  "projects.hlm.title": "Shops – HLM Shopping Center",
  "projects.hlm.type": "Shops – 12 m²",
  "projects.ndiakhirate.booking.fees": "File fees 250,000 FCFA",
  "projects.ndiakhirate.booking.deposit": "VEFA mode - 40% deposit on reservation",
  "projects.ndiakhirate.booking.balance": "Balance released according to work progress",
  "projects.ndiakhirate.booking.financing": "Bank financing possible",
  "projects.ndiakhirate.floor": "G+1",
  "projects.ndiakhirate.localisation": "Ndiakhirate",
  "projects.ndiakhirate.price": "35,000,000 FCFA",
  "projects.ndiakhirate.reservationConditions": "File fees 250,000 FCFA\nVEFA mode - 40% deposit on reservation\nBalance released according to work progress\nBank financing possible",
  "projects.ndiakhirate.title": "Housing",
  "projects.ndiakhirate.type": "Villa – 150 m²",
  "projects.ndiakhirate.typeF3": "F3 type",
  "projects.ndiakhirate.typeF4": "F4 type",
  "projects.ndiakhirate.typeR1": "G+1 F4 type",
  "projects.ndiakhirate.titleF3": "F3 type housing – Ndiakhirate",
  "projects.ndiakhirate.titleF4": "F4 type housing – Ndiakhirate",
  "projects.ndiakhirate.titleR1": "G+1 F4 type housing – Ndiakhirate",
  "projects.ndiakhirate.description": "This iconic housing project includes residential units, green spaces and modern amenities, with a focus on sustainability and well-being. The houses offer beautiful natural light, while common areas encourage an active lifestyle, creating an urban haven where modernity and tranquility harmonize.",
  "projects.ndiakhirate.address": "Ndiakhirate Residences",
  "projects.ndiakhirate.features": [
    "Individual houses",
    "Green spaces",
    "Family environment",
    "Easy access"
  ],
  "projects.parcelsTitle": "Serviced plots",
  "projects.sirena.address": "Sirena Residences",
  "projects.sirena.description": "The Sirena program offers modern and functional apartments as well as nearby shops. A setting designed for an urban, dynamic and secure lifestyle.",
  "projects.sirena.features": [
    "Garden",
    "2 kitchens (African and American)",
    "Accessible site close to amenities",
    "Modern architecture",
    "Master suite",
    "Parking"
  ],
  "projects.sirena.programPlus": "Program highlights",
  "projects.sirena.booking.fees": "",
  "projects.sirena.booking.deposit": "VEFA mode - 30% deposit on reservation",
  "projects.sirena.booking.balance": "Balance released according to work progress",
  "projects.sirena.booking.financing": "Bank financing possible",
  "projects.sirena.floor": "G+1",
  "projects.sirena.localisation": "Almadies",
  "projects.sirena.price": "350,000,000 FCFA",
  "projects.sirena.duration": "24 months",
  "projects.sirena.reservationConditions": "VEFA mode - 30% deposit on reservation\nBalance released according to work progress\nBank financing possible",
  "projects.sirena.title": "Sirena Residences – Almadies",
  "projects.sirena.type": "G+1 Villa – 250 m²",
  "projects.title": "OUR PROJECTS",
  "projects.tivaouane.address": "Tivaouane Peulh Housing",
  "projects.tivaouane.description": "This iconic housing project includes residential units, green spaces and modern amenities, with a focus on sustainability and well-being. The houses offer beautiful natural light, while common areas encourage an active lifestyle, creating an urban haven where modernity and tranquility harmonize.",
  "projects.tivaouane.features": [
    "Housing",
    "Complete infrastructure",
    "Developed public spaces",
    "Modern G+5 buildings"
  ],
  "projects.tivaouane.programPlus": "Program highlights",
  "projects.tivaouane.booking.fees": "File fees 250,000 FCFA",
  "projects.tivaouane.booking.deposit": "40% deposit on reservation",
  "projects.tivaouane.booking.balance": "Balance released according to work progress",
  "projects.tivaouane.booking.financing": "Bank financing possible",
  "projects.tivaouane.floor": "G+5",
  "projects.tivaouane.localisation": "Tivaouane Peulh",
  "projects.tivaouane.price": "25,000,000 FCFA",
  "projects.tivaouane.reservationConditions": "File fees 250,000 FCFA\nVEFA mode - 40% deposit on reservation\nBalance released according to work progress\nBank financing possible",
  "projects.tivaouane.title": "Housing - Tivaouane Peulh",
  "projects.tivaouane.type": "Villa – 150 m²",
  "projects.viewDetails": "View details",

  // =========================
  // CONTACT
  // =========================
  "contact.address.title": "Address",
  "contact.address.value": "Fann-Hock – Corniche opposite Supreme Court, BP 1270, Dakar, Senegal",
  "contact.coordinates": "Our contact details",
  "contact.description": "Our team remains at your disposal to answer all your questions and support you in your projects.",
  "contact.directions": "Get directions",
  "contact.email.title": "Email",
  "contact.form.email": "Email",
  "contact.form.email.placeholder": "Your email",
  "contact.form.message": "Message",
  "contact.form.message.placeholder": "Your message",
  "contact.form.name": "Full name",
  "contact.form.name.placeholder": "Your name",
  "contact.form.phone": "Phone",
  "contact.form.phone.placeholder": "Your phone number",
  "contact.form.send": "Send message",
  "contact.form.sending": "Sending...",
  "contact.form.subject": "Subject",
  "contact.form.subject.information": "Information request",
  "contact.form.subject.other": "Other",
  "contact.form.subject.partnership": "Partnership",
  "contact.form.subject.placeholder": "Your subject",
  "contact.form.subject.quote": "Quote request",
  "contact.form.title": "Send us a message",
  "contact.headquarters": "SOCABEG Head Office",
  "contact.hero.subtitle": "Our team is listening to answer all your questions",
  "contact.hero.title": "Contact us to start\na promising collaboration",
  "contact.highlight": "CONTACT US",
  "contact.hours.title": "Opening hours",
  "contact.hours.value": "Monday - Friday: 8 AM - 6 PM\nSaturday & Sunday: Closed",
  "contact.location.title": "Our location",
  "contact.phone.title": "Phone / Fax",
  "contact.social": "Follow us",
  "contact.title": "CONTACT",

  // =========================
  // FOOTER
  // =========================
  "footer.about": "About",
  "footer.achievements": "Our projects",
  "footer.company": "SOCIÉTÉ D'AMÉNAGEMENT DE BÂTIMENT ET D'ÉTUDES GÉNÉRALES - BUILDING SENEGAL'S FUTURE TOGETHER",
  "footer.construction": "Construction",
  "footer.contact": "Contact",
  "footer.description": "Senegalese company specializing in construction, real estate development and mining.",
  "footer.group": "THE GROUP",
  "footer.join": "Join us",
  "footer.legal": "Legal notices",
  "footer.mining": "Mining",
  "footer.realEstate": "Real Estate Development",
  "footer.rights": "All rights reserved",
  "footer.usefulLinks": "USEFUL LINKS",
  "footer.legal_column": "LEGAL",
  "footer.privacy": "Privacy Policy",

  // =========================
  // LEGAL NOTICES
  // =========================
  "legal.title": "Legal notices",
  "legal.editor.title": "Website publisher",
  "legal.editor.company": "Company name",
  "legal.editor.legalForm": "Legal form",
  "legal.editor.address": "Head office",
  "legal.editor.phone": "Phone",
  "legal.editor.email": "Email",
  "legal.publication.title": "Publication director",
  "legal.publication.responsible": "Responsible",
  "legal.development.title": "Website development",
  "legal.development.text": "Website designed and developed by",
  "legal.hosting.title": "Hosting",
  "legal.hosting.text": "The site is hosted by OVH.",
  "legal.intellectual.title": "Intellectual property",
  "legal.intellectual.text1": "The entire site is subject to Senegalese and international legislation on copyright and intellectual property. All reproduction rights are reserved, including for downloadable documents and iconographic and photographic representations.",
  "legal.intellectual.text2": "Reproduction of all or part of this site on any electronic medium whatsoever is strictly prohibited without express authorization from the publication director.",
  "legal.liability.title": "Liability limitation",
  "legal.liability.text1": "SOCABEG strives to ensure, to the best of its ability, the accuracy and updating of the information published on this site, and reserves the right to correct, at any time and without prior notice, the content.",
  "legal.liability.text2": "SOCABEG declines all liability:",
  "legal.liability.point1": "For any inaccuracy, error or omission concerning information available on the site.",
  "legal.liability.point2": "For any damage resulting from fraudulent intrusion by a third party leading to modification of information made available on the site.",
  "legal.liability.point3": "And more generally for any damage, direct or indirect, whatever the causes, origins, nature or consequences.",
  "legal.links.title": "Hypertext links",
  "legal.links.text": "The creation of hypertext links to the site www.socabeg.com is subject to prior agreement from the Publication Director. SOCABEG is in no way responsible for the content of sites that are the subject of a hypertext link from the site www.socabeg.com.",
  "legal.applicable.title": "Applicable law",
  "legal.applicable.text": "The site www.socabeg.com and its content are governed by Senegalese law. Any dispute relating to this site falls under the exclusive jurisdiction of Senegalese courts.",

  // =========================
  // PRIVACY POLICY
  // =========================
  "privacy.title": "Privacy Policy",
  "privacy.lastUpdate": "Last updated",
  "privacy.introduction.title": "Introduction",
  "privacy.introduction.text1": "SOCABEG is committed to protecting the privacy of users of its website. This privacy policy explains how we collect, use, disclose and protect your personal information when you visit our website.",
  "privacy.introduction.text2": "By using our site, you accept the practices described in this privacy policy.",
  "privacy.collection.title": "Information collection",
  "privacy.collection.intro": "We collect the following types of information:",
  "privacy.collection.provided.title": "Information you provide us",
  "privacy.collection.provided.intro": "When you fill out a form on our site, we may collect personal information such as:",
  "privacy.collection.provided.item1": "First and last name",
  "privacy.collection.provided.item2": "Email address",
  "privacy.collection.provided.item3": "Phone number",
  "privacy.collection.provided.item4": "Postal address",
  "privacy.collection.provided.item5": "Any other information you choose to provide us",
  "privacy.collection.automatic.title": "Automatically collected information",
  "privacy.collection.automatic.intro": "When you visit our site, we may automatically collect certain information, including:",
  "privacy.collection.automatic.item1": "IP address",
  "privacy.collection.automatic.item2": "Browser type",
  "privacy.collection.automatic.item3": "Pages visited",
  "privacy.collection.automatic.item4": "Time spent on the site",
  "privacy.collection.automatic.item5": "Information about the device used",
  "privacy.usage.title": "Use of information",
  "privacy.usage.intro": "We use the collected information to:",
  "privacy.usage.item1": "Provide, operate and maintain our website",
  "privacy.usage.item2": "Respond to your requests and questions",
  "privacy.usage.item3": "Send you information about our services",
  "privacy.usage.item4": "Improve our website and services",
  "privacy.usage.item5": "Analyze site usage to improve our offerings",
  "privacy.usage.item6": "Detect and prevent fraud",
  "privacy.sharing.title": "Information sharing",
  "privacy.sharing.intro": "We do not sell, trade or rent your personal information to third parties. We may share your information in the following situations:",
  "privacy.sharing.item1": "With service providers who help us operate our site",
  "privacy.sharing.item2": "To comply with the law or respond to legal process",
  "privacy.sharing.item3": "To protect our rights, property or safety",
  "privacy.sharing.item4": "In the event of merger, acquisition or asset sale, in which case you will be informed",
  "privacy.retention.title": "Data retention",
  "privacy.retention.text": "We retain your personal information for as long as necessary to achieve the purposes described in this privacy policy, unless a longer retention period is required or permitted by law.",
  "privacy.rights.title": "Your rights",
  "privacy.rights.intro": "You have certain rights regarding your personal information, including:",
  "privacy.rights.item1": "The right to access your personal information",
  "privacy.rights.item2": "The right to rectify inaccurate information",
  "privacy.rights.item3": "The right to request deletion of your information",
  "privacy.rights.item4": "The right to object to the processing of your information",
  "privacy.rights.item5": "The right to data portability",
  "privacy.rights.contact": "To exercise these rights, please contact us at the address indicated below.",
  "privacy.security.title": "Data security",
  "privacy.security.text": "We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure or destruction.",
  "privacy.changes.title": "Changes to the privacy policy",
  "privacy.changes.text": "We may update this privacy policy from time to time. The date of the last update will be indicated at the top of this page. We encourage you to regularly review this policy to stay informed of how we protect your information.",
  "privacy.contact.title": "Contact us",
  "privacy.contact.intro": "If you have any questions regarding this privacy policy, please contact us at:",
  "privacy.contact.email": "Email",
  "privacy.contact.phone": "Phone",
  "privacy.contact.address": "Address",

  // =========================
  // OTHER
  // =========================
  "notFound.backHome": "Back to home",
  "notFound.contact": "For any information, please contact us:",
  "notFound.email": "Email:",
  "notFound.message": "Oops! The page you are looking for does not exist or has been moved.",
  "notFound.phone": "Phone:",
  "notFound.title": "Page not found",
  "page.careers.title": "Careers | SOCABEG",
  "page.privacy.title": "Privacy Policy | SOCABEG",
  "page.projet.title": "Project | SOCABEG",
  "page.realisations.title": "Projects | SOCABEG",
  "page.terms.title": "Terms of use | SOCABEG",
  "page.underConstruction.title": "Under construction | SOCABEG",
  "realEstateDetail.amenities": "Amenities and services",
  "realEstateDetail.backToList": "Back to project list",
  "realEstateDetail.booking.terms": "Reservation conditions",
  "realEstateDetail.booking.title": "Book now",
  "realEstateDetail.contactInfo": "Contact information",
  "realEstateDetail.contactUs": "Contact us",
  "realEstateDetail.features": "Features",
  "realEstateDetail.location": "Location",
  "realEstateDetail.noAmenities": "No specific amenities listed for this project.",
  "realEstateDetail.price": "Price (excluding notary fees)",
  "realEstateDetail.projectDescription": "Project description",
  "realEstateDetail.projectNotFound": "Project not found",
  "realEstateDetail.viewOnGoogleMaps": "View on Google Maps",
  "superficie": "Area",
  "naturePapier": "Land title type",
  "statut": "Status",
  "underConstruction.contact": "For any information, please contact us:",
  "underConstruction.email": "Email:",
  "underConstruction.message": "This page is under development. Come back soon to discover its content. Thank you for your patience.",
  "underConstruction.phone": "Phone:",
  "underConstruction.title": "Under construction"
};

export default enTranslations;
